import { render } from "./CompanyMenu.vue?vue&type=template&id=29b92e96&lang=pug"
import script from "./CompanyMenu.vue?vue&type=script&lang=js"
export * from "./CompanyMenu.vue?vue&type=script&lang=js"

import "./CompanyMenu.vue?vue&type=style&index=0&id=29b92e96&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__